import { Card, CardContent, Typography } from "@mui/material";
import React, { PropsWithChildren } from "react";

interface Props {
  title: string;
}

const TodayCard: React.FC<PropsWithChildren<Props>> = (props) => {
  const { children, title } = props;
  return (
    <Card sx={{ bgcolor: "background.default", minWidth: 275 }}>
      <CardContent>
        <Typography
          variant="h6"
          component="h6"
          gutterBottom
          // sx={{ mt: 4, mb: 2 }}
        >
          {title}
        </Typography>
        {children}
      </CardContent>
    </Card>
  );
};

export default TodayCard;
